"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTransactionEventObject = void 0;
const TSalesOrderType_1 = require("../../types/TSalesOrderType");
const isDeliverySalesOrderItem_1 = require("../isDeliverySalesOrderItem");
const createTransactionEventObject = (salesOrder) => Object.assign({
    transactionId: salesOrder.salesOrderId,
    transactionAffiliation: salesOrder.retailLocation.title,
    transactionCustomer: salesOrder.retailCustomer.retailCustomerId,
    transactionTotal: salesOrder.totalPrice,
    transactionTax: salesOrder.totalPrice * 0.1,
    transactionShipping: salesOrder.type === TSalesOrderType_1.TSalesOrderType.Delivery
        ? salesOrder.salesOrderItems.find(item => (0, isDeliverySalesOrderItem_1.isDeliverySalesOrderItem)(item, env.deliveryId)).price
        : 0,
    transactionProducts: JSON.stringify(salesOrder.salesOrderItems
        // don't show delivery in the list of products
        .filter((salesOrderItem) => !(0, isDeliverySalesOrderItem_1.isDeliverySalesOrderItem)(salesOrderItem, env.deliveryId))
        .map((salesOrderItem) => ({
        sku: salesOrderItem.productId,
        name: salesOrderItem.title,
        category: salesOrderItem.category.label,
        price: salesOrderItem.price,
        quantity: salesOrderItem.quantity
    })))
}, Object.assign({}, (salesOrder.promotions && {
    transactionPromotions: JSON.stringify(salesOrder.promotions.map((promotion) => ({
        description: promotion.description,
        type: promotion.type,
        priceDiscounted: promotion.priceDiscounted
    })))
})));
exports.createTransactionEventObject = createTransactionEventObject;
//# sourceMappingURL=createTransactionEventObject.js.map